import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import './App.css';
import BackgroundPattern from './components/BackgroundPattern';
import Hero from './components/Hero';
import IdentityBand from './components/IdentityBand';
import Domains from './components/Domains';
import Signal from './components/Signal';
import Coordinates from './components/Coordinates';
import Footer from './components/Footer';
import Navigation from './components/Navigation';

// Show nav after scrolling past this fraction of the viewport height
const NAV_SHOW_THRESHOLD = 0.8;

function App() {
  const [showNav, setShowNav] = useState(false);

  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        setShowNav(window.scrollY > window.innerHeight * NAV_SHOW_THRESHOLD);
        ticking = false;
      });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="app">
      <Helmet>
        <title>./v8 — Vishaal Hariprasad</title>
        <meta name="description" content="Builder. Operator. Student." />
        <meta property="og:title" content="./v8 — Vishaal Hariprasad" />
        <meta property="og:description" content="Builder. Operator. Student." />
        <meta property="og:type" content="website" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link
          href="https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400;500;600;700&family=Inter:wght@300;400;500;600&family=Cormorant+Garamond:ital,wght@0,400;1,400&display=swap"
          rel="stylesheet"
        />
      </Helmet>

      <a href="#hero" className="skip-to-content">Skip to content</a>

      <BackgroundPattern />
      <Navigation show={showNav} />

      <main>
        <Hero />
        <IdentityBand />
        <Domains />
        <Signal />
        <Coordinates />
        <Footer />
      </main>
    </div>
  );
}

export default App;
